<div class="app-top" [class.app-top--full-width]="fullWidth" [class.app-top--boxed-width]="boxedWidth">
    <div class="container">
        <img class="logo" src="assets/img/misc/medbook-logo-sm.svg" alt="Medbook logo">
        @if (isTrial()) { <a [routerLink]="'settings/billing' | prefixSubscription" class="trial-stamp">{{'top_trial_mode_stamp' | translate}}</a> }
        <div class="help"><span>{{'top_need_help' | translate}} </span> <a href="mailto:{{'misc_helpdesk_email' | translate}}">{{'misc_helpdesk_email' | translate}}</a></div>
    </div>
</div>